import React from 'react';
import UserDateInformationContainer from '../../../common/UserDateInformationContainer';
import { isChemicalSafetyExpert } from '../../../../behavior/init/selectors';
import useUser from '@behavior/init/getUserV2';

type Props = {
  disabled: boolean;
  chemicalProductDisabled: boolean;
  isChemProdRouter: boolean;
  initialData: any;
  setFieldValue: (name: string, value: any) => void;
  setMarkAsChecked: () => void;
  toggleValidationMessage: () => void;
  setValidateOnChange: (value: boolean) => void;
  values: any;
};

const CPValidateInformationContainer = ({
  disabled,
  chemicalProductDisabled,
  isChemProdRouter,
  initialData,
  values,
  setFieldValue,
  setValidateOnChange,
}: Props) => {
  const { user } = useUser();
  const isCSE = isChemicalSafetyExpert(user);

  return (
    <UserDateInformationContainer
      disabled={disabled || chemicalProductDisabled || !isCSE}
      accordionTitle="chemical.product.details.page.validate.inf.container.title"
      initialData={initialData}
      userLabel="chemical.product.details.page.validate.inf.container.validate.user.input"
      userName={'chemicalProduct.validateUser'}
      dteLabel="chemical.product.details.page.validate.inf.container.validate.dte.input"
      dteName={'chemicalProduct.validateDte'}
      closable={false}
      openDirection={isChemProdRouter ? 'down' : 'up'}
      values={values}
      setFieldValue={setFieldValue}
      setValidateOnChange={setValidateOnChange}
    />
  );
};

export default React.memo(CPValidateInformationContainer);
